export * from './offene-gutachten-sorter.component';
export * from './offene-gutachten-sorter.component.module';